import {
  IDialogContentStyles,
  IDialogFooterStyles
} from '@fluentui/react/lib/Dialog';
import { FontWeights, IRawStyle, ITheme } from '@fluentui/react/lib/Styling';
import { FontSizes } from '../teams-type';

export const getDialogContentStyles = (
  themeName: string,
  theme: ITheme
): Partial<IDialogContentStyles> => {
  const styles = {
    title: {
      fontSize: FontSizes.size18,
      fontWeight: FontWeights.bold,
      padding: '27px 54px 8px 32px',
      lineHeight: FontSizes.size24,
      color: theme.palette.neutralDark
    },
    topButton: {
      padding: '23px 22px 4px 0',
      fontSize: FontSizes.size14,
      selectors: {
        '.ms-Dialog-button': {
          color: theme.palette.neutralDark
        },
        '.ms-Dialog-button:hover': {
          color: theme.palette.themePrimary,
          selectors: {
            i: {
              fontWeight: FontWeights.bold
            }
          }
        },
        '.ms-Dialog-button:active': {
          color: theme.palette.themePrimary
        }
      }
    },
    inner: {
      padding: '1px 32px 0px 32px',
      color: theme.palette.neutralDark,
      selectors: {
        '.ms-Label': {
          color: theme.palette.neutralDark
        }
      }
    },
    innerContent: {
      paddingTop: '4px',
      marginBottom: '20px'
    },
    subText: {
      color: theme.palette.neutralDark,
      fontWeight: FontWeights.regular,
      fontSize: FontSizes.size14,
      lineHeight: FontSizes.size20,
      paddingTop: 0
    }
  } as Partial<IDialogContentStyles>;

  // Contrast theme overrides
  if (themeName === 'contrast') {
    ((styles.topButton as Required<IRawStyle>).selectors[
      '.ms-Dialog-button:hover'
    ] as IRawStyle).color = theme.palette.themeDark;
    ((styles.topButton as Required<IRawStyle>).selectors[
      '.ms-Dialog-button:active'
    ] as IRawStyle).color = theme.palette.themeDark;

    (styles.inner as IRawStyle).color = theme.palette.black;
    ((styles.inner as Required<IRawStyle>).selectors[
      '.ms-Label'
    ] as IRawStyle).color = theme.palette.black;
  }
  return styles;
};

export const getDialogFooterStyles = (
  _themeName: string,
  _theme: ITheme
): Partial<IDialogFooterStyles> => {
  const styles = {
    actions: {
      margin: '16px 0 0'
    }
  } as Partial<IDialogFooterStyles>;

  return styles;
};
